import { environment } from '@/environments/environment'
import useJwt from '@/auth/jwt/useJwt'
const services = [
  { name: 'validateRecaptcha', url: `${environment.apiPlatform}/v1/validate-recaptcha?response={response}&expectedAction={expectedAction}`, method: 'post' },
  { name: 'exchangeToken', url: `${environment.apiPlatform}/v1/token-exchange`, method: 'post'},
  { name: 'updatePermissionUser', url: `${environment.apiPlatform}/v1/update-permission-user`, method: 'post'},
  { name: 'syncOauthUser', url: `${environment.apiPlatform}/v1/sync-oauth-user`, method: 'post'}
]

export default class Login {
  constructor (context) {
    this.context = context
  }
  
  async callService (name, queryParams = {}, params = {}, config = {}, headers = {}) {
    const service = services.filter(service => service.name === name)[0]
    return useJwt.genericService(service, queryParams, params, config, headers)
  }
}